import { memo } from "react";
import { useParams } from "react-router-dom";
import type { PackageTypeRouteT } from "../../../../models/models";
import Icon from "../../../../../../Elements/Icon/Icon";

const AddonIcon = memo(() => {
  const { packageType } = useParams<{
    packageType: PackageTypeRouteT;
  }>();
  
  switch (packageType!) {
    case "sub-users":
      return (
        <Icon name="sub-users-image" iconClass="sub-user-image" ext="png" xxl />
      );
    case "extra-storage":
      return (
        <Icon name="cloud-storage" iconClass="sub-user-image" ext="svg" xxl />
      );
    default:
      return <></>;
  }
});

export default AddonIcon;
